<template>
  <label :class="facetModifier" class="Facet" data-ht-element="filter-value" :data-ht-meta-name="value.label">
    <input type="checkbox" :checked="isSelected" @change="onChange" :value="value.label" />
    <span v-if="isColor" class="swatch" :style="`background-color: ${value.swatch.color};`"></span>
    <span :class="textModifier">
      {{ value.label }}
    </span>
  </label>
</template>

<script setup>
import { ref, watch, computed, onBeforeMount } from 'vue';

const emits = defineEmits(['handle-selection']);
const props = defineProps({
  id: String,
  value: Object,
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const selected = computed(() => {
  return props.isSelected ? 'Facet--Selected' : '';
});

const isColor = computed(() => props.id.includes('color'));

const facetModifier = computed(() => {
  const isColorFacet = isColor.value ? 'Facet--Color' : '';
  const isSelected = selected.value ? 'Facet--Selected' : '';
  return `${isColorFacet} ${isSelected}`;
});

const textModifier = computed(() => {
  return selected.value ? 't4' : 'p4';
});

const outputtedMetaobjectId = () => {
  const id = props.value.id.split('gid-shopify-metaobject-')[1].trim();
  return `gid://shopify/Metaobject/${id}`;
};

const onChange = () => {
  const data = {};
  data[props.id] = isColor.value ? outputtedMetaobjectId() : props.value.label;
  data.applied = !props.isSelected;
  emits('handle-selection', data);
};
</script>
